import React, { useContext } from 'react'
import moment from 'moment'
import GeoContext from 'contexts/geoContext'
import { OfferPageState } from 'contexts/OfferPage/offerPageStateReducer'
import { withOfferPageAndReduxState } from 'contexts/OfferPage/withOfferPageState'
import { OfferPackageOptionView } from 'selectors/offerPage/offerPageSelectors'
import { VIRGIN_VELOCITY_PARTNERSHIP_CODE } from 'constants/partnerships'
import Group from 'components/utils/Group'
import OfferPackagePartnershipLabel from 'components/Common/Labels/OfferPackagePartnershipLabel'
import FlashCancellationPolicies from 'components/Common/CancellationPolicies/Flash/FlashCancellationPolicies'
import useIsAvailableForPurchase from '../../hooks/useIsAvailableForPurchase'
import FlashHotelOptionPriceDetailsVariant from './FlashHotelOptionPriceDetailsVariant'

interface Props {
  offer: App.Offer;
  checkIn: moment.Moment;
  packageView: OfferPackageOptionView;
  previewMode: boolean;
}

function FlashHotelRateOptionVariant(props: Props) {
  const {
    offer,
    checkIn,
    packageView,
    previewMode,
  } = props

  const { partnership } = useContext(GeoContext)
  const availableForPurchase = useIsAvailableForPurchase()
  const { package: pkg } = packageView

  const showPartnership = (packageView.hotelAvailable &&
    !!partnership?.hasEarn &&
    offer.canEarnPartnershipPoints &&
    pkg.partnership &&
    partnership?.code !== VIRGIN_VELOCITY_PARTNERSHIP_CODE)

  const showPrices = (packageView.capacityValid && packageView.hotelAvailable) || previewMode

  return (
    <Group direction="vertical" gap={16} data-testid={pkg.uniqueKey}>
      {availableForPurchase && offer.property && pkg.roomRate && <FlashCancellationPolicies
        checkInDate={checkIn}
        propertyTimezoneOffset={offer.property.timezoneOffset}
        cancellationPolicy={pkg.roomRate.cancellationPolicy}
      />}
      <Group direction="vertical" gap={8}>
        {!!showPartnership && <OfferPackagePartnershipLabel
          offer={offer}
          price={packageView.hotelPrice}
          />}
        {showPrices && <FlashHotelOptionPriceDetailsVariant packageView={packageView} />}
      </Group>
    </Group>
  )
}

export default withOfferPageAndReduxState((state: OfferPageState, appState: App.State) => ({
  checkIn: state.checkInDate,
  partnership: appState.geo.partnership,
  previewMode: appState.config.previewMode,
}))(FlashHotelRateOptionVariant)
